import React, { Component } from "react";
import Chevron from "./Chevron";
import { translate } from '../Services/translation';
import clsx from "clsx";
import PropTypes from "prop-types";

class VariantChooser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVariants: false,
        };

        this.handleMenu = this.handleMenu.bind(this);
    }

    // Block end
    handleMenu() {
        const currentVariantShow = this.state.showVariants;
        this.setState({ showVariants: !currentVariantShow });
    }

    render() {
        if (!Array.isArray(this.props.variants) || this.props.variants.length <= 1) {
            return null;
        }

        const selectedVariant = this.props.variants.find(x => x.selected) || null;
        if (!selectedVariant) {
            return null;
        }

        return (
            <div>
                <span className="variant__title">{translate('variantselectortitle')}</span>
                <button className="variantChooser-button" onClick={this.handleMenu}>
                    <img
                        className="variantchooser-image"
                        src={selectedVariant.image}
                        alt={selectedVariant.imageAlt} />
                    <div className="variantChooser-content">
                        <span className="variantChooser-content-title">
                            {selectedVariant.title}

                            {selectedVariant.description && (
                                <div
                                    className="variantChooser-content-description">{selectedVariant.description}</div>
                            )}
                        </span>
                    </div>
                    <Chevron
                        className={
                            "variantChooser-chevron " +
                            (this.state.showVariants ? "active" : "")
                        }
                    />
                </button>
                <div
                    className="variantChooser"
                    aria-expanded={this.state.showVariants ? "true" : "false"}
                >
                    <ul className={clsx("variantChooser-list", { active: this.state.showVariants })}>
                        {this.props.variants.filter(x => !x.selected).map(item => (
                            <li key={item.id}>
                                <a href={item.url}>
                                    <img
                                        className="variantchooser-image"
                                        src={item.image}
                                        alt={item.imageAlt}
                                        role="presentation"
                                    />
                                    <div className="variantChooser-content">
                                        <span className="variantChooser-content-title">
                                            {item.title}

                                            {item.description && (
                                                <div
                                                    className="variantChooser-content-description">{item.description}</div>
                                            )}
                                        </span>

                                        <span className="variantChooser-content-price">
                                            {item.price}
                                        </span>
                                    </div>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

VariantChooser.propTypes = {
    variants: PropTypes.array.isRequired,
    onVariantSelect: PropTypes.func,
    className: PropTypes.string,
};

export default VariantChooser;
